import { render, staticRenderFns } from "./IconSupportOutline.vue?vue&type=template&id=23a8cec0"
import script from "./IconSupportOutline.vue?vue&type=script&lang=js"
export * from "./IconSupportOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports